import React from "react";
import Cards from "../components/Cards";

const Projects = () => {
  return (
    <div>
      <Cards />
    </div>
  );
};

export default Projects;
